export default "__VITE_ASSET__D32lUpLO__"